import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { AgentComponent } from '../agent/agent.component';
import { AgentUserComponent } from '../agent-user/agent-user.component';


@Component({
  selector: 'app-agent-list',
  templateUrl: './agent-list.component.html',
  styleUrls: ['./agent-list.component.css']
})
export class AgentListComponent implements OnInit {

  public menu_item_id = '120';
  public add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  displayedColumns = ['acct_number', 'customer_name', 'mobile', 'phone1', 'user_name', 'limit_amount', 'balance', 'remain_balance', 
    'add_user', 'change_pass', 'edit', 'del'];
  displayedColumns2 = ['acct_number', 'customer_name', 'mobile', 'phone1', 'user_name', 'limit_amount', 'balance', 'remain_balance'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<AgentComponent>;
  addUserDialogRef: MatDialogRef<AgentUserComponent>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'customer', 'customer_name': '', 'acct_number': '', 'mobile': '',
    'phone1': '', 'branch_id': '-1', 'title': 'قائمة الوكلاء'
  };
  branchList = [];
  Agent_List; Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private router: Router,
    public translate: TranslateService) {
      this.getMessages(translate);
    }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Agent_List').subscribe((res: string) => {
      this.Agent_List = res;
    });
    this.model['title'] = this.Agent_List;

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.push({ 'branch_id': '0', 'branch_name': 'مشترك لجميع الفروع', 
            'branch_name_en': 'Common to all branches' });
        
        this.branchList.unshift({ 'branch_id': '-1', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });
  }

  search() {
    let condition = "";

    if (this.model['acct_number'] != '')
      condition += " AND `customer`.`acct_number` = '" + this.model['acct_number'] + "'";

    if (this.model['customer_name'] != '')
      condition = " AND (`customer`.`customer_name` LIKE '%" + this.model['customer_name'] +
        "%' OR `customer`.`customer_name_en` LIKE '%" + this.model['customer_name'] + "%')";

    if (this.model['mobile'] != '')
      condition += " AND `customer`.`mobile` LIKE '%" + this.model['mobile'] + "%'";

    if (this.model['phone1'] != '')
      condition += " AND (`customer`.`phone1` LIKE '%" + this.model['phone1'] + "%' OR `customer`.`phone2` LIKE '%" + this.model['phone1'] + "%')";
  
    if (this.model['branch_id'] != '-1')
      condition += " AND `customer`.`branch_id` = '" + this.model['branch_id'] + "'";

    else if (this.model['branch_id'] == '-1') {
      let index = 1;
      let list_length = this.branchList.length;

      condition += " AND `customer`.`branch_id` IN (";
      this.branchList.forEach(element => {
        if (element.branch_id != '-1') {
          if (index < list_length)
            condition += " '" + element.branch_id + "',";
          else if (index == list_length)
            condition += " '" + element.branch_id + "'";
        }
        index++;
      });
      condition += ")";
    }
    let obj;
    let query = "SELECT `customer`.*, (CASE WHEN `customer`.`city_id` = '0' THEN '0' ELSE (SELECT `country`.`country_id` FROM `city`, `country` " + 
      " WHERE `customer`.`city_id` = `city`.`city_id` AND `city`.`country_id` = `country`.`country_id`) END) AS 'country_id'" +
      " FROM `customer` WHERE `customer`.`is_agent` = '1'" + condition + " AND `customer`.`status` = '1'";

    obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];

        this.dp.forEach(element => {
          element.balance = '0';
          element.remain_balance = '0';

          // get agent limit and balance
          obj = { cmd: 'getAcctBalance', acct_number: element.acct_number, acct_type: 'acct', for_agent: '1' };
 
          this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();

              element.balance = (Number(data.status['msg']) * -1).toString();
              element.remain_balance = (Number(element.limit_amount) - Number(data.status['msg'])).toString();
            });
        });

        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
        this.model['acct_number'] = '';
      });
  }

  newAgent() {
    this.addDialogRef = this.dialog.open(AgentComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success') {
          this.model['acct_number'] = result['acct_number'];
          this.search();
        }
      });
  }

  addAgentUser(row) {
    let dialog_data = {
      'table_name': 'customer', 'customer_id': row.customer_id,
      'customer_name': row.customer_name,
      'customer_name_en': row.customer_name_en,
      'acct_number': row.acct_number,
      'flag': 'update', 
      'key': 'customer_id',
      'user_name': '', 
      'user_password': ''
    };

    this.addUserDialogRef = this.dialog.open(AgentUserComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addUserDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success') {
          this.model['acct_number'] = result['acct_number'];
          this.search();
        }
      });
  }

  changeAgentPass(row) {
    let dialog_data = {
      'table_name': 'customer', 'customer_id': row.customer_id,
      'customer_name': row.customer_name,
      'customer_name_en': row.customer_name_en,
      'acct_number': row.acct_number,
      'flag': 'update', 
      'key': 'customer_id',
      'user_name': row.user_name, 
      'user_password': '',
      'change_pass': true
    };

    this.addUserDialogRef = this.dialog.open(AgentUserComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addUserDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success') {
          this.model['acct_number'] = result['acct_number'];
          this.search();
        }
      });
  }

  editAgent(row) {
    let dialog_data = [{
      'table_name': 'customer', 'customer_id': row.customer_id,
      'customer_name': row.customer_name,
      'customer_name_en': row.customer_name_en,
      'acct_number': row.acct_number,
      'national_id': row.national_id,
      'customer_category_id': row.customer_category_id,
      'city_id': row.city_id,
      'tax_no': row.tax_no,
      'address': row.address,
      'mobile': row.mobile,
      'phone1': row.phone1,
      'phone2': row.phone2,
      'fax': row.fax,
      'email': row.email,
      'bank_name': row.bank_name,
      'bank_acct_number': row.bank_acct_number,
      'represent1': row.represent1,
      'represent1_mobile': row.represent1_mobile,
      'represent2': row.represent2,
      'represent2_mobile': row.represent2_mobile,
      'customer_cr': row.customer_cr,
      'def_rep_no': row.def_rep_no,
      'claim_day': row.claim_day,
      'comment': row.comment,
      'key': 'customer_id',
      'flag': 'update',
      'car_type': row.car_type,
      'car_model': row.car_model,
      'car_color': row.car_color,
      'is_account': row.is_account,
      'limit_amount': row.limit_amount
    }, { 'country_id': row.country_id }];

    this.addDialogRef = this.dialog.open(AgentComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success') {
          this.model['acct_number'] = result['acct_number'];
          this.search();
        }
      });
  }

  delAgent(row) { 
    if (confirm(this.Del_Msg)) {

      let values = [{ 'table_name': this.model['table_name'], 'acct_number': row.acct_number },
        // { 'table_name': 'traveler_info', 'acct_number': row.acct_number },
        { 'table_name': 'sub_acct', 'acct_number': row.acct_number }];

      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.model['acct_number'] = row.acct_number;
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Agent_List + ' </td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('agent_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }
}
